document.addEventListener('DOMContentLoaded',function() {

    const el = document.getElementsByClassName('js-tabs');

    const thisindex = function(elm) {
        let nodes = elm.parentNode.childNodes, node, i = 0, count = 0;
        while( (node = nodes.item(i++)) && node != elm ) {
            if( node.nodeType == 1 ) count++;
        }
        return count;
    }

    const init = function() {

        const showTab = function(idx, contentItem, navItem) {
            for (let i = 0; i < contentItem.length; i ++) {

                contentItem[i].classList.remove('is-visible');

                setTimeout(function() {
                    contentItem[i].classList.remove('is-active');

                    if (i === idx) {
                        contentItem[i].classList.add('is-active');

                        setTimeout(function() {
                            contentItem[i].classList.add('is-visible');
                        }, 1);
                    }
                }, 150);
            }

            for (let j = 0; j < navItem.length; j ++) {
                navItem[j].classList.remove('is-active');
            }
        };

        for (let i = 0; i < el.length; i++) {
            const content = el[i].getElementsByClassName('js-content')[0],
                  contentItem = content.getElementsByClassName('js-tab'),
                  nav = el[i].getElementsByClassName('js-nav')[0],
                  navItem = nav.getElementsByClassName('js-tab');

            for (let j = 0; j < navItem.length; j ++) {
                navItem[j].addEventListener('click', function() {
                    showTab(thisindex(this), contentItem, navItem);
                    this.classList.add('is-active');

                    if(this.dataset.latitude && this.dataset.longitude && window.jumpToPosition !== undefined) {
                        window.jumpToPosition(this.dataset.longitude, this.dataset.latitude);
                    }

                    if(this.dataset.address && document.getElementById(this.dataset.address)) {
                        const addressBoxEl = document.getElementById(this.dataset.address);
                        addressBoxEl.classList.remove('o-hidden');
                        document.querySelectorAll('.c-contactaddress').forEach((item) => {
                            if(item.id !== this.dataset.address) {
                                item.classList.add('o-hidden');
                            }
                        });
                    }
                });
            }
        }
    }

    el.length > 0 ? init() : false;

}, false);
